import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FaviconManager = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/contact-settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error fetching company settings for favicon:', error);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (!settings) return;

    // Update favicon
    if (settings.favicon_url) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = settings.favicon_url;
    }

    // Update page title - use custom site_title if set, otherwise use company name
    const title = settings.site_title || `${settings.company_name} | Technology & Construction`;
    document.title = title;

    // Update meta description
    const description = settings.site_description || `${settings.company_name} - Integrated Construction and Green Digital Solutions.`;
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    }

    // Update Open Graph tags
    const updateMetaTag = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      }
    };

    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    if (settings.logo_url) {
      updateMetaTag('og:image', settings.logo_url);
    }

    // Update Twitter tags
    const updateTwitterTag = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      }
    };

    updateTwitterTag('twitter:title', title);
    updateTwitterTag('twitter:description', description);
    if (settings.logo_url) {
      updateTwitterTag('twitter:image', settings.logo_url);
    }

  }, [settings]);

  return null;
};

export default FaviconManager;
